import { GoodgameSignal } from "./GoodgameSignal";

/**
 *  IntSignal
 *
 *     @author Alexander
 */

export class IntSignal extends GoodgameSignal {
    constructor() {
        super(Number);
    }

    public signal(_int: number): void {
        super.dispatch(_int);
    }
}
